const state = {
  componente: []
}

const getters = {
  allSComponente (state) {
    return this.componente
  }
}

const actions = {
  setStand (context, params) {
    context.commit('SETCOMPONENTE', params)
  }
}

const mutations = {
  SETSTAND (state, params) {
    state.componente = params
    localStorage.setItem('componentes', state.componente)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/componentes.js